// extracted by mini-css-extract-plugin
export default {"ag-styles":"x_g","detailCellRenderer":"x_cq"};